import { useLinhaDoTempo } from "./use-linha-do-tempo";
import { LinhaDoTempoView } from "./view-linha-do-tempo";

export function LinhaDoTempo() {
  const vm = useLinhaDoTempo();

  return <LinhaDoTempoView {...vm} />;
}

export type * from "./types-linha-do-tempo";
